import { ApolloError, useMutation } from '@apollo/client'
// eslint-disable-next-line import/no-named-as-default
import Router from 'next/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbars } from 'settle-ui/hooks/useSnackbars/useSnackbars'
import { RouterPage } from 'lib/navigation/consts'
import {
  UpdatePayerInvitationHookDocument,
  type UpdatePayerInvitationHookVariables,
} from './useUpdatePayerInvitation.graphql'

interface Params {
  onSuccess?: () => void
}

export const useUpdatePayerInvitation = ({ onSuccess }: Params = {}) => {
  const { t } = useTranslation()
  const { showError, showApolloOrTextError } = useSnackbars()
  const [loading, setLoading] = useState(false)
  const [mutate] = useMutation(UpdatePayerInvitationHookDocument)

  const updatePayerInvitation = async (variables: UpdatePayerInvitationHookVariables) => {
    try {
      setLoading(true)
      const phoneNumber = variables.phoneNumber?.replace(/\D/g, '')

      await mutate({ variables: { ...variables, phoneNumber } })
      await onSuccess?.()
      setLoading(false)
    } catch (err) {
      if (err instanceof ApolloError) {
        err.graphQLErrors.forEach(({ extensions }) => {
          if (extensions?.code === 'business_exists') {
            Router.push({ pathname: RouterPage.login })
            showError(t('onboarding::validation::businessExists'))
          } else {
            showApolloOrTextError(err)
          }
        })
      } else {
        showError(t('somethingWentWrong'))
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    updatePayerInvitation,
    loading,
  }
}
